module.exports = __webpack_public_path__ + "static/media/add floor.c81bb501.svg";